import { render } from "./WeekendImageGallery.vue?vue&type=template&id=8d6bc67c&scoped=true"
import script from "./WeekendImageGallery.vue?vue&type=script&lang=js"
export * from "./WeekendImageGallery.vue?vue&type=script&lang=js"

import "./WeekendImageGallery.vue?vue&type=style&index=0&id=8d6bc67c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6bc67c"]])

export default __exports__